import { Pipe } from '@angular/core';
import { Drug, MedicalTest } from '../models/';

@Pipe({
  name: 'addToCartText'
})
export class AddToCartTextPipe {
  transform(cartItems: (MedicalTest | Drug)[], product: MedicalTest | Drug) {
    return cartItems.some(item => item.id === product.id) ? 'Remove this item from cart' 
      : 'Want to add this item to cart?';
  }
}
